// extracted by mini-css-extract-plugin
export default {"quote":"QuoteSection_quote__3JOK8","text":"QuoteSection_text__4VeX5","quoteText":"QuoteSection_quoteText__km9KK","quoteAuthor":"QuoteSection_quoteAuthor__hE4cP"};